module.exports = {"520324001":"凤仪街道","520324002":"瑞濠街道","520324101":"瑞溪镇","520324102":"和溪镇","520324103":"安场镇","520324104":"土坪镇","520324105":"流渡镇","520324106":"格林镇","520324107":"新州镇","520324108":"庙塘镇","520324109":"小雅镇","520324110":"中观镇","520324111":"芙蓉江镇","520324112":"班竹镇","520324113":"碧峰镇","520324114":"乐俭镇","520324115":"杨兴镇","520324116":"桴焉镇","520324202":"谢坝仡佬族苗族乡","520324203":"市坪苗族仡佬族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520324.json
// module id = 2601
// module chunks = 0